import ApiHandler from '@/api/base'
import { CUSTOM_FILTERS_TYPE_IDS } from '@/utils/custom-filters'

class OkrFiltersApiHandler extends ApiHandler {
  async createFilterViewForUser({ filters, name, typeId = CUSTOM_FILTERS_TYPE_IDS.ELEMENTS } = {}) {
    const { data } = await this.http.post('/createFilterViewForUser', {
      filters,
      name,
      typeId
    })
    return data
  }

  async getFiltersForUser({
    accountId,
    workspaceId,
    typeId = CUSTOM_FILTERS_TYPE_IDS.ELEMENTS
  } = {}) {
    const { data } = await this.http.post('/getFiltersForUser', {
      accountId,
      workspaceId,
      typeId
    })
    return data
  }

  async deleteFilterView(filterViewId) {
    const { data } = await this.http.post('/deleteFilterView', {
      filterViewId
    })
    return data
  }

  async updateFilterViewForUser({ filters, name, filterViewId }) {
    const { data } = await this.http.post('/updateFilterViewForUser', {
      filters,
      name,
      filterViewId
    })
    return data
  }

  async getCustomFiltersForFeed({ accountId } = {}) {
    return await this.getFiltersForUser({
      accountId,
      workspaceId: null,
      typeId: CUSTOM_FILTERS_TYPE_IDS.CHECKINS
    })
  }

  async createCustomFilterForFeed({ filters, name } = {}) {
    return await this.createFilterViewForUser({
      filters,
      workspaceId: null,
      name,
      typeId: CUSTOM_FILTERS_TYPE_IDS.CHECKINS
    })
  }

  async updateCustomFilterOrder({ filters, name, filterViewId, orderValue } = {}) {
    const { data } = await this.http.post('/updateFilterViewForUser', {
      filterViewId,
      filters,
      name,
      orderValue
    })
    return data
  }
}

export default OkrFiltersApiHandler
